import React, { FC, useEffect, useState } from "react";
import { useAppSelector } from "../../store";
import { getTournoi } from "../../features/tournoi/tournoiSlice";
import {
  Box,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
  Zoom,
} from "@mui/material";

interface ContactUsProps {}

const ContactUs: FC<ContactUsProps> = () => {
  const tournoi = useAppSelector(getTournoi);
  const [iframeHeight, setIframeHeight] = useState(300);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // sm = 600px

  useEffect(() => {
    const updateHeight = () => {
      const toolbarHeight = 64;
      const padding = 24 * 2;
      const alertHeight = isMobile ? 130 : 120;
      const availableHeight =
        window.innerHeight - toolbarHeight - padding - alertHeight;
      setIframeHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [isMobile]);

  if (!tournoi) return null;

  const mailto = `mailto:${tournoi.mail}`;

  return (
    <Zoom in>
      <Stack spacing={2}>
        {/* Box Styled in place of Alert with a lighter background */}
        <Box
          sx={{
            bgcolor: theme.palette.secondary.main, // Lighter background
            borderRadius: 2,
            padding: 2,
            boxShadow: 3,
            animation: "fadeIn 0.5s ease-in-out",
          }}
        >
          <Typography
            variant={isMobile ? "body2" : "body1"}
            color="text.primary"
          >
            Pour toute question concernant le tournoi, vous pouvez nous
            contacter à l'adresse{" "}
            <a
              href={mailto}
              style={{
                color: theme.palette.text.primary, // Lien bien visible
                textDecoration: "underline",
              }}
            >
              {tournoi.mail}
            </a>
          </Typography>
          <Typography
            variant={isMobile ? "body2" : "body1"}
            color="text.primary"
          >
            Le tournoi se déroulera à {tournoi.adresse}.
          </Typography>
        </Box>

        {/* Map Embed */}
        <Box
          sx={{
            width: "100%",
            height: iframeHeight,
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 2,
            animation: "fadeIn 0.5s ease-in-out",
          }}
        >
          <iframe
            title={tournoi.mapsTitle}
            src={tournoi.maps}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        </Box>
      </Stack>
    </Zoom>
  );
};

export default ContactUs;
